import { LocationWithVariablesInterface, NormalizedFMSUnitInterface, UnitInterface } from "@swivl-mono/types";

import { APIService } from "../Service/API.Service";

//LINK - apps/server/src/API/Units/Units.Controller.ts
export class UnitsAPI {
  static async createUnit(orgId: number, unit?: NormalizedFMSUnitInterface) {
    return APIService.Server.post<UnitInterface>(`/units/org/${orgId}/unit`, unit);
  }

  static async createUnits(orgId: number, units?: NormalizedFMSUnitInterface[]) {
    return APIService.Server.post<UnitInterface[]>(`/units/org/${orgId}/units`, units);
  }

  static async updateUnits(orgId: number, units: NormalizedFMSUnitInterface[]) {
    return APIService.Server.put<UnitInterface[]>(`/units/org/${orgId}/units`, units);
  }

  static async deleteUnits(orgId: number, unitIds: number[]) {
    return APIService.Server.delete<UnitInterface[]>(`/units/org/${orgId}/units`, null, unitIds);
  }

  static async getUnitsByLocationId(orgId: number, locationId: number, params?: { available?: boolean }) {
    return APIService.Server.get<UnitInterface[]>(`/units/org/${orgId}/location/${locationId}`, params);
  }

  /**
   * Available-unit counts per location in one batched call (ENG-2867).
   * Locations with zero available units are omitted from the returned map.
   */
  static async getAvailableUnitCountsForLocations(orgId: number, locationIds: number[]) {
    return APIService.Server.get<Record<number, number>>(`/units/org/${orgId}/available-unit-counts`, { locationIds });
  }

  static async getUnitByExternalUnitId(orgId: number, locationId: number, externalUnitId: string) {
    return APIService.Server.get<UnitInterface>(`/units/org/${orgId}/location/${locationId}/external-unit/${externalUnitId}`);
  }

  static async updateUnit(orgId: number, locationId: number, unitId: number, unit?: NormalizedFMSUnitInterface) {
    return APIService.Server.put<UnitInterface>(`/units/org/${orgId}/location/${locationId}/unit/${unitId}`, unit);
  }

  static async deleteUnit(orgId: number, locationId: number, unitId: number) {
    return APIService.Server.delete<UnitInterface>(`/units/org/${orgId}/location/${locationId}/unit/${unitId}`);
  }

  static async getUnitsAndLocationsNearPostalCode(orgId: number, postalCode: string) {
    return APIService.Server.get<{ location: LocationWithVariablesInterface<any>; units: UnitInterface[] }[]>(
      `/units/org/${orgId}/get-units-and-locations-near-postal-code/${postalCode}`
    );
  }
}
